module.exports = __webpack_public_path__ + "static/img/logo_9.09432d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo_9.png
// module id = iUc0
// module chunks = 1